import http from "../utils/http";

export default {

  async createRequest(data) {
    return http({
      url: `api/coaching-request`,
      method: "post",
      data
    });
  },
  async validateDiscountCoe(profileId, discountCode) {
    return http({
      url: `api/coaching-request/discount/${profileId}/${discountCode}`,
      method: "get",
    });
  },
  async fulfillRequest(sessionId) {
    return http({
      url: `api/coaching-request/fulfill/${sessionId}`,
      method: "get",
    });
  },
  
};
